export const UNIQUE_FIELD_LABELS: Record<string, string> = {
  cap_iq_id: 'Cap IQ ID',
  sacra_domain: 'Sacra Domain',
  zanbato_id: 'Zanbato ID',
};

export const UNIQUE_FIELDS = ['cap_iq_id', 'sacra_domain', 'zanbato_id'] as const;
